import { DataCampaigns, ICampaignsState } from "../@types";
import { campaignsActions } from "../action-types";

type campaignsActionType =
  | { type: typeof campaignsActions.CAMPAIGNS_MODAL_STATE }
  | {
      type: typeof campaignsActions.GET_CAMPAIGN_FOR_UPDATE;
      payload: DataCampaigns;
    }
  | { type: typeof campaignsActions.IS_CAMPAIGNS_FOR_UPDATE; payload: boolean }
  | {
      type: typeof campaignsActions.SWITCH_CAMPAIGNS_REFRESH_TABLE;
      payload: boolean;
    }
  | {
      type: typeof campaignsActions.SWITCH_CAMPAIGNS_PRODUCTS_REFRESH_TABLE;
      payload: boolean;
    };

const INITIAL_STATE: ICampaignsState = {
  campaignsForUpdate: undefined,
  isUpdateCampaign: false,
  campaignsModalIsOpen: false,
  refreshTableCampaigns: false,
  refreshTableCampaignsProducts: false,
};

export default function campaignsReducer(
  state: ICampaignsState = INITIAL_STATE,
  action: campaignsActionType
): ICampaignsState {
  switch (action.type) {
    case campaignsActions.CAMPAIGNS_MODAL_STATE:
      return {
        ...state,
        campaignsModalIsOpen: !state.campaignsModalIsOpen,
      };
    case campaignsActions.GET_CAMPAIGN_FOR_UPDATE:
      return {
        ...state,
        campaignsForUpdate: action.payload,
      };
    case campaignsActions.IS_CAMPAIGNS_FOR_UPDATE:
      return {
        ...state,
        isUpdateCampaign: action.payload,
      };
    case campaignsActions.SWITCH_CAMPAIGNS_REFRESH_TABLE:
      return {
        ...state,
        refreshTableCampaigns: action.payload,
      };
    case campaignsActions.SWITCH_CAMPAIGNS_PRODUCTS_REFRESH_TABLE:
      return {
        ...state,
        refreshTableCampaignsProducts: action.payload,
      };
    default:
      return state;
  }
}
